import { render } from "./App.vue?vue&type=template&id=0d439f7d"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0d439f7d&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__